// Mesh Tools page
import { MeshTools } from '../components/MeshTools';

export function MeshToolsPage() {
  return (
    <div className="pt-32 pb-20">
      <MeshTools />
    </div>
  );
}

